import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["slide", "counter"]
  connect() { this.index = 0; this.show() }
  previous() { this.index--; this.show() }
  next() { this.index++; this.show() }
  touchstart(event) { this.startX = event.changedTouches[0].clientX }
  touchend(event) {
    const distance = event.changedTouches[0].clientX - this.startX
    if (Math.abs(distance) > 50) distance > 0 ? this.previous() : this.next()
  }
  show() {
    const count = this.slideTargets.length
    if (!count) return
    this.index = (this.index + count) % count
    this.slideTargets.forEach((slide, index) => slide.classList.toggle("hidden", index !== this.index))
    this.counterTarget.textContent = `${this.index + 1} / ${count}`
  }
}
